export const WORKER_ATTR_NAME = 'workerAttr';

